import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import './Vendor.css';
import { useNavigate, useLocation } from 'react-router-dom';
import TopHeader from '../Common/TopHeader';
import { ActivateDeactivate, Checkeligibility, DisplayErrorMessages, DisplayToaster, PostApiMethod, restrictIntialSpace, textValidator } from '../../core/services/apiService';
import AppModal from '../AppModal/AppModal';

const VendorForm = () => {

    const [loader, setLoader] = useState(false);
    const [domainCheck, setDomainCheck] = useState("");
    const [showPopUp, setShowPopUp] = useState<boolean>(false);
    const location = useLocation();

    const { register, handleSubmit, formState: { errors }, setError, getValues } = useForm<any>();

    Checkeligibility("/customer/edit", location, "/customer");

    const navigate = useNavigate();

    const pageDisable = () => {
        setLoader(true);
        document.body.classList.add('page-disable');
    };

    const pageEnable = () => {
        setLoader(false);
        document.body.classList.remove('page-disable');
    };

    const allowedExtensionTypes: any = ["jpg", "png", "jpeg"];
    const pattern = new RegExp(/^[a-zA-Z0-9-_]+$/i);
    const handleRegistration = (data: any) => {

        const payloadValue = [{ value: data.name, minLength: 4, maxLength: 40, key: 'name' }, { value: data.domain, minLength: 4, maxLength: 40, key: 'domain' }];
        const validation = textValidator(payloadValue);
        if (validation && validation.validation === true && validation.error) {
            validation.error.forEach(errorCase => {
                setError(errorCase.key, { type: errorCase.type });
            });
            return false;
        }
        if (data.logo.length > 0) {
            const fileExtension = data.logo[0].name.split(".").at(-1);
            if (!allowedExtensionTypes.includes(fileExtension)) {
                DisplayToaster("bg-danger", `The supported file formats are : ${allowedExtensionTypes.join(", ")}`);
                return false;
            }
        }

        if (!(data.callTimeout === null || data.callTimeout === "" || data.callTimeout === "undefined") && (data.callTimeout < 10 || data.callTimeout > 60)) {
            DisplayToaster("bg-danger", "Call Timeout should be between 10 to 60 seconds");
            return false;
        }
        const form_Data = new FormData();
        form_Data.append('name', data.name.trim());
        if (data.domain.toLowerCase().trim() === "admin" || data.domain.toLowerCase().trim() === "agent") {
            setDomainCheck("Domain field should not be admin or agent");
            return false;
        } else if (!pattern.test(data.domain.toLowerCase().trim())) {
            setDomainCheck("Domain field should not contain special characters and spaces");
            return false;
        } else {
            form_Data.append('domain', data.domain.trim().toLowerCase());
        }
        form_Data.append("logo", location.pathname === "/customer/create" ? data.logo[0] : (data.logo[0] ? data.logo[0] : ""));
        if (!(data.maxLocations === null || data.maxLocations === "" || data.maxLocations === "undefined")) {
            form_Data.append("maxLocations", data.maxLocations);
        }
        if (!(data.maxAgents === null || data.maxAgents === "" || data.maxAgents === "undefined")) {
            form_Data.append("maxAgents", data.maxAgents);
        }

        if (!(data.callTimeout === null || data.callTimeout === "" || data.callTimeout === "undefined")) {
            form_Data.append("call_timeout", data.callTimeout);
        }
        form_Data.append('notification_timeout', data.notification_timeout);

        pageDisable()
        // axios.post(apiBases + '/admin/vendor', form_Data, config)
        PostApiMethod(location.pathname === "/customer/create" ? 'admin/vendor' : `admin/vendor/${location.state?.id}`, form_Data)
            .then((res) => {
                pageEnable();
                DisplayToaster("bg-success", "Customer " + data.name + " " + (location.pathname === "/customer/create" ? "created" : "updated") + "  successfully");
                navigate('/customer');
            }).catch((err) => {
                pageEnable();
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            })
    };

    return (
        <>
            <Container fluid className="mt-4" >
                <TopHeader
                    // heading="Create Customer"
                    heading={(location.pathname === '/customer/create') ? "Create Customer" : (location.pathname === '/customer/edit') ? "Edit Customer - " + location.state?.name : " Customer"}
                    to={"/customer"}
                    className="fa-list"
                    action="List"
                    id="customer-list"
                />

                {
                    showPopUp &&
                    (
                        <AppModal
                            title={`Confirm To ${location.state.is_active ? "Deactivate" : "Activate"}!`}
                            bodyText={
                                `Are you sure to ${location.state.is_active ? "deactivate" : "activate"} this Customer? The associated Customer Admin will be ${location.state.is_active ? "deactivated" : "activated"} as well`
                            }
                            primaryButtonLabel={"Yes"}
                            secondaryButtonLabel={"No"}
                            primaryButtonEventEmitter={() => { ActivateDeactivate("Customer", location.state?.name, "admin/vendor", location.state.id, location.state.is_active, () => { navigate('/customer') }); setShowPopUp(false) }
                            }
                            secondaryButtonEventEmitter={() => setShowPopUp(false)}
                        />
                    )
                }

                <Form onSubmit={handleSubmit(handleRegistration)} className="mt-3">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Name <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" defaultValue={location.state?.name} onKeyDown={(e) => { restrictIntialSpace(e) }} className="form-control"
                                {...register('name', { required: true, minLength: 4, maxLength: 40 })} />
                            {errors.name && errors.name.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name && errors.name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.name && errors.name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                        </div>

                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Domain <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-2 mb-2'>
                            <input type="text" defaultValue={location.state?.domain} onKeyDown={(e) => { restrictIntialSpace(e) }} className="form-control" {...register('domain', { required: true, minLength: 4, maxLength: 40, onChange: (e) => { setDomainCheck("") } })} />
                            {errors.domain && errors.domain.type === "required" && <small className='text-danger' >Domain is required</small>}
                            {errors.domain && errors.domain.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                            {errors.domain && errors.domain.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                            {<small className='text-danger'>{domainCheck}</small>}
                        </div>
                        <div className='col-md-2'>
                            <input type="text" defaultValue={process.env.REACT_APP_DOMAIN_URL} disabled className="form-control" />
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Logo <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="file" id="fileInput" accept='image/*' className="form-control" {...register('logo', { required: location.pathname === "/customer/create" ? true : false })} />
                            <small className="text-primary">Supported formats : {allowedExtensionTypes.join(", ")} </small><br />
                            {errors.logo && <small className='text-danger' >Logo is required</small>}
                            {
                                location.pathname === "/customer/edit" && <small className='text-primary' ><img
                                    alt=""
                                    src={location.state?.logo}
                                    height="auto"
                                    className="d-inline-block align-top"
                                    style={{ maxWidth: 200 }}
                                ></img></small>
                            }
                        </div>
                    </div>

                    {
                        location.pathname === "/customer/edit" && <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Status </label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text" className='form-control' value={!location.state?.is_active ? "Inactive" : "Active"} disabled />
                            </div>
                        </div>
                    }

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Max Locations </label>
                        </div>
                        <div className='col-md-4'>
                            <input type="number" defaultValue={location.state?.maxLocations} placeholder="3" className="form-control"
                                {...register('maxLocations', { validate: (value) => ((getValues('maxLocations').length) && parseInt(value) >= (location.pathname === "/customer/create" ? 1 : location.state?.maxLocations)) })} />
                            {(errors.maxLocations?.type === "validate" && location.pathname === "/customer/create") && <small className='text-danger' >Max Locations should be more than 1</small>}
                            {(errors.maxLocations?.type === "validate" && location.pathname === "/customer/edit") && <small className='text-danger' >The location count cannot be decreased as you have already created {location.state?.maxLocations} locations. </small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Max Agents </label>
                        </div>
                        <div className='col-md-4'>
                            <input type="number" defaultValue={location.state?.maxAgents} placeholder="6" className="form-control"
                                {...register('maxAgents', { validate: (value) => ((getValues('maxAgents').length) && parseInt(value) >= (location.pathname === "/customer/create" ? 1 : location.state?.maxAgents)) })} />
                            {(errors.maxAgents?.type === "validate" && location.pathname === "/customer/create") && <small className='text-danger' >Max Agents should be more than 1</small>}
                            {(errors.maxAgents?.type === "validate" && location.pathname === "/customer/edit") && <small className='text-danger' >The agent count cannot be decreased as you have already created {location.state?.maxAgents} agents. </small>}
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Call Timeout (Seconds) </label>
                        </div>
                        <div className='col-md-4'>
                            <input type="number" defaultValue={location.state?.callTimeout} placeholder="10" className="form-control" {...register('callTimeout')} />
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Kiosk Motion Notification Video Timeout (Minutes) <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="number" defaultValue={location.state?.notification_timeout} placeholder="2" className="form-control"
                                {...register('notification_timeout', { required: true, validate: (value) => (parseInt(value) >= 2 && parseInt(value) <= 15) })} />
                            {errors.notification_timeout?.type === "required" && <small className='text-danger' >Kiosk Motion Notification Video Timeout is required</small>}
                            {errors.notification_timeout?.type === "validate" && <small className='text-danger' >Kiosk Motion Notification Video Timeout should be between 2 to 15 minutes</small>}
                        </div>
                    </div>
                    <div className='text-center'>
                        <button type="submit" className='btn btn-primary app-button-color m-2'>{loader && (<span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>)} {(location.pathname === '/customer/create') ? "Submit" : (location.pathname === '/customer/edit') ? "Update" : "Submit"}</button>
                        {location.pathname === "/customer/edit" && <Button variant={location.state?.is_active ? "danger" : "success"} onClick={(e) => { setShowPopUp(true) }}> {location.state?.is_active ? "Deactivate" : "Activate"} </Button>}
                        <button type="reset" className='btn btn-secondary m-2' onClick={(e) => { navigate('/customer'); }}>Cancel</button>
                    </div>
                </Form>
            </Container>
        </>
    )

}

export default VendorForm;